export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.d33c37f4.worker.js");
}
